import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class MobileReceiveVehicleService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get vehicle details
   * @param vehicle_id
   */
  getVehicleDetails(vehicle_id: string){

    let apiURL:string=`${this.baseURL}/v1/get-transferred-vehicle-on-transit-details/${vehicle_id}`;

    return this.http.get(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
  * Get available spare parts when vehicle was released
  * @returns Observable<ApiResponse>
  */
  getSparePartsAvailableOnRelease(transferLogId: string): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/spare-parts-available-on-vehicle-release/${transferLogId}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

   /**
     * Receive transferred vehicle
     * @param vehicleId
     * @param chassisNo
     * @param selectedSpareParts
     * @param driverName
     * @param locationId
     * @param comment
     * @param userId
     * @param transferLogId
     * @returns
     */
    receive(vehicleId: string, chassisNo: string, selectedSpareParts: any[],driverName:string,locationId:string, comment: string|null,userId:string,transferLogId:string): Observable<any> {

      let apiURL:string=`${this.baseURL}/v1/transfer-receive-vehicle`;

      const data = {
        vehicle_id: vehicleId,
        chassis_no:chassisNo,
        selected_spare_parts: selectedSpareParts,
        driver_name:driverName,
        location_id:locationId,
        comment:comment,
        user_id:userId,
        transfer_log_id:transferLogId
      };

      return this.http.post<any>(apiURL, data);
    }
}
